export class Config {
    name = '';
    data = {};
    configTypeId = '';
    tags: any = {};
};